<script >
import {deleteOffice, officeList, saveOrUpdateOffice} from "@/api/office";
import router from "@/router";

export default {
  name: 'officeList',
  data() {
    return {
      officeList: [],
      officeListLoading: false,
      officeListTotal: 0,
      current: 1,
      pageSize: 10,
      query: null,
      visible : false,
      officeForm : {},
      rules: {
        name: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
          {min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur'}
        ],
      },
    }
  },

  mounted() {
    this.fetchOfficeList()
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.current = 1;
      this.fetchOfficeList()
    },
    handleCurrentChange(val) {
      this.current = val;
      this.fetchOfficeList()
    },
    clearList(){
      this.current = 1
      this.officeList = []
    },
    handleSearch(){
      this.clearList();
      this.fetchOfficeList();
    },
    async fetchOfficeList() {
      if (this.officeListLoading) return;

      this.officeListLoading = true;
      const param = {
        current : this.current,
        size : this.pageSize,
        "filter": [
          {
            "name": "deleted",
            "value": 0,
            "type": "EQ"
          }
        ],
        sorted: [
          {
            "name": "createdTime",
            "type": "DESC"
          }
        ],
      }

      if (this.query && this.query.length > 0){
        param.filter.push({
          name: 'name',
          type: 'LIKE',
          value: this.query
        })
      }
      try {
        const res = await officeList(param)
        if (res && res.code === "0000"){
          this.officeList = res.result.records || []
          this.officeListTotal = res.result.total
        }
      } catch (e) {
      } finally {
        this.officeListLoading = false;
      }
    },
    handleEdit(item){
      this.visible = true
      this.officeForm = item
    },
    enableOffice(item){
      const param = {
        ...item
      }
      param.enabled = item.enabled === 1 ? 0 : 1
      saveOrUpdateOffice(param).then(res => {
        if (res && res.code === "0000"){
          this.$message.success('操作成功')
          this.fetchOfficeList()
        }
      }).catch().finally(() => {
        this.visible = false
      })
    },
    async submitForm(){
      const data = this.officeForm
      this.$refs.officeFormRef.validate(async (valid) => {
        if (valid) {
          if (data.id) {
            // 编辑
          }else {
            // 新增
            data.enabled = 1
            data.deleted = 0
          }

          saveOrUpdateOffice(data).then(res => {
            if (res && res.code === "0000"){
              this.$message.success('操作成功')
              this.clearList();
              this.fetchOfficeList()
            }
          }).catch().finally(() => {
            this.visible = false
          })
        }
      })


    },

    async deleteOffice(id) {
      this.$confirm('确定要删除该企业吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        deleteOffice(id).then(res => {
          if (res && res.code == "0000") {
            this.$message.success('企业删除成功')
            this.clearList();
            this.fetchOfficeList()
          }
        })

      })
    },

    goCompany(id) {
      this.$router.push({
        name: 'company',
        query: { id: id }
      });
    },

  },
}

</script>

<template>
  <div>
    <el-card class="main-card">
      <div slot="header" class="card-header">
        <div style="display: flex; align-items: center; gap: 6px">
          <div>企业名称：</div>
          <el-input  v-model="query" placeholder="请输入企业名称" style="width: 200px;" clearable @clear="() => {
            this.clearList();
            this.fetchOfficeList();
          }"/>
          <el-button type="primary" @click="handleSearch" >搜索</el-button>
        </div>

        <el-button type="primary" @click="visible = true">添加企业</el-button>
      </div>

      <el-table :data="officeList" border stripe highlight-current-row>
        <el-table-column prop="name" label="企业名称" show-overflow-tooltip />
        <el-table-column prop="enabled" label="是否启用" width="80">
          <template slot-scope="scope">
                <span :style="scope.row.enabled ? 'color: green' : 'color: red' "
                >{{ scope.row.enabled ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" />

        <el-table-column label="操作" width="160" fixed="right">
          <template slot-scope="scope">
            <el-link @click="goCompany(scope.row.id)" >详情</el-link>
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button size="mini" type="text" @click="deleteOffice(scope.row.id)" style="color: red">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="current" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="officeListTotal"
                       class="pagination"></el-pagination>
      </div>
    </el-card>


    <el-dialog title="添加企业" :visible.sync="visible" width="30vw">
      <div>
        <el-form ref="officeFormRef" :model="officeForm" label-width="80px" :rules="rules">
          <el-form-item label="企业名称" prop="name">
            <el-input v-model="officeForm.name" placeholder="请输入企业名称" />
          </el-form-item>
        </el-form>
        <div style="display: flex; align-items: center; justify-content: right; width: 100%">
          <el-button @click="officeForm = {}">重置</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </div>
      </div>
    </el-dialog>

  </div>

</template>

<style >
/* 主卡片样式 */
.main-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

/* 搜索区域 */
.filter-bar {
  display: flex;
  margin: 20px;
  align-items: center;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

}

/* 分页样式 */
.pagination-container {
  margin: 20px;
  padding-top: 15px;
  border-top: 1px solid #f0f2f5;
  text-align: right;
}

</style>
